<template>
    <!-- Bonif1 = descuento a farmacia-->
    <!-- Ca1, Ca2 = cantidades para descuento x cantidad-->
    <!-- Po1, Po2 = descuento aumentado para farmacia (en caso de cumplir la cantidad y ser mayor al descuento anterior)-->
    <v-hover v-slot:default="{ hover }">
        <v-card
            width="280px"
            height="100%"
            color="grey lighten-4"
            class="mx-auto"
        >
            <v-img
                height="230px"
                :src="getImg(product.dibujo)"
                :alt="product.desite"
            >
                <v-expand-transition>
                    <div
                        v-if="hover"
                        class="d-flex transition-fast-in-fast-out azul lighten-2 v-card--reveal display-3 white--text"
                        style="height: 100%;"
                    >
                        %
                        {{ getMayorDiscount(product) }}
                    </div>
                </v-expand-transition>
            </v-img>
            <div>
                <!--titulo-->
                <v-card-title class="azul--text title pb-0 mb-0">
                    <strong class="azul--text text-center">
                        Descuento: %
                        {{ getMayorDiscount(product) }}
                    </strong>
                </v-card-title>
                <!--subtitulo-->
                <v-card-subtitle
                    class="azul--text pb-0 mb-0 desc"
                    style="position: relative;"
                >
                    <div
                        class="container font-weight-light text-center descripcion pt-6 pb-0"
                    >
                        {{ getDesc(product) }}
                        <!-- descuentos -->
                        <div class="container pt-5">
                            <!-- Descuento por cantidad 1 -->
                            <div v-if="(validateQuantityDiscount(product))">
                                <div
                                    class="text-center justify-center red--text"
                                >
                                    <h2>
                                        x{{ product.ca1 }}
                                        <v-icon color="red">
                                            mdi-sale
                                        </v-icon>
                                        {{ getQuantityDiscount(product) }}
                                    </h2>
                                </div>
                            </div>
                            <!-- Descuento por cantidad 2 -->

                            <div v-if="(validateQuantityDiscount2(product))">
                                <div
                                    class="text-center justify-center red--text"
                                >
                                    <h2>
                                        x{{ product.ca2 }}
                                        <v-icon color="red">
                                            mdi-sale
                                        </v-icon>
                                        {{ getQuantityDiscount2(product) }}
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card-subtitle>
                <!--boton-->
                <v-card-actions height="50px" class="pt-0 mt-0">
                    <div class="d-flex flex-row mx-5 px-4">
                        <div class="cant">
                            <v-text-field
                                v-model="cantidad"
                                type="number"
                                append-outer-icon="add"
                                prepend-icon="remove"
                                @click:append-outer="increment"
                                @click:prepend="decrement"
                            />
                        </div>
                        <div class="pt-2 mt-2 px-6 mx-6">
                            <v-btn
                                color="azul"
                                dark
                                size="15"
                                @click="agregarACarro()"
                            >
                                <v-icon color="white">
                                    mdi-cart
                                </v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-card-actions>
            </div>
        </v-card>
    </v-hover>
</template>

<script>
import { mapMutations } from 'vuex';
import gd from '../utils/getDesc';
import gmd from '../utils/Discounts/getMayorDiscount';
import gqd from '../utils/Discounts/getQuantityDiscount';
import gqd2 from '../utils/Discounts/getQuantityDiscount2';
import vqd from '../utils/Discounts/validateQuantityDiscount';
import vqd2 from '../utils/Discounts/validateQuantityDiscount2';

export default {
    props: {
        product: {
            type: Object,
            required: true
        }
    },

    data: () => ({
        cantidad: 1
    }),

    methods: {
        ...mapMutations('products', ['ADDTOCART']),

        getDesc: gd,
        getMayorDiscount: gmd,
        getQuantityDiscount: gqd,
        getQuantityDiscount2: gqd2,
        validateQuantityDiscount: vqd,
        validateQuantityDiscount2: vqd2,

        increment() {
            this.cantidad = parseInt(this.cantidad, 10) + 1;
        },
        decrement() {
            if (this.cantidad > 1) {
                this.cantidad = parseInt(this.cantidad, 10) - 1;
            }
        },
        getImg(p) {
            let img = 'img/' + p.replace('\\', '/');
            if (img === 'img/productos/') {
                img = 'img/logos/logo-solo-ciafarma.png';
            }
            return `/${img}`;
        },

        agregarACarro() {
            this.ADDTOCART({
                product: this.product,
                cantidad: this.cantidad > 0 ? this.cantidad : 1
            });
        }
    }
};
</script>
<style scoped>
.azul--text /deep/ label {
    color: #184087;
}
/* Remove text field arrows */
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
.title {
    font-size: 1.1rem;
}
.desc {
    padding-top: 10px;
    height: 7.5rem !important;
    font-size: 1rem;
}
.descripcion {
    height: 5.5rem !important;
}

.cant {
    width: 6rem;
}
.v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: 0.5;
    position: absolute;
    width: 100%;
}
</style>
